import React, { useEffect, useState } from "react";
import Articles from "./Articles";
import { fetchArticles, fetchPopularPosts } from "../actions/articleActions";
import Loading from "../components/Loading";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import Actions from "../components/Actions";
import NotFound from "./NotFound";

// import withArticle from "../Hocs/withArticle";
import withFetchErrorHandler from "../Hocs/withFetchErrorHandler";
import PopularList from "../components/PopularList";
import TopRatedList from "../components/TopRatedList";
import TopAuthor from "../components/TopAuthor";
const WithFetchErrorHandlerArticles = withFetchErrorHandler(Articles);
const TopCommentedWithFetchHandler = withFetchErrorHandler(PopularList);
const TopRatedWithFetchHandler = withFetchErrorHandler(TopRatedList);
const TopAuthorWithFetchHandler = withFetchErrorHandler(TopAuthor);
const ArticleLists = () => {
  const [top, setTop] = useState({
    topCommented: null,
    topRated: null,
    topAuthor: null,
  });
  const [articles, setArticles] = useState();
  useEffect(() => {
    (async function getTopPosts() {
      const { topCommented, topRated, topAuthor } = await fetchPopularPosts();

      setTop({ topCommented, topRated, topAuthor });
    })();
    return () => setTop("");
  }, []);

  useEffect(() => {
    setTimeout(() => {
      (async function fetchArticlesLists() {
        const response = await fetchArticles();

        setArticles(response);
      })();
    });

    return () => {
      setArticles("");
    };
  }, []);

  return (
    <div className="article-list-container widthContainer">
      <Actions setArticles={setArticles} />
      <Router>
        <Switch>
          <Route exact path="/articles-list/articles/">
            <WithFetchErrorHandlerArticles
              articles={articles}
              message="Publish your own article now!"
            />
          </Route>
          <div className="top-articles-container">
            <Route exact path="/articles-list/articles/top5/most-commented">
              <TopCommentedWithFetchHandler
                articles={top.topCommented}
                message="Publish and make everyone talk about it!"
              />
            </Route>
            <Route exact path="/articles-list/articles/top5/top-rated">
              <TopRatedWithFetchHandler
                articles={top.topRated}
                message="Publish and be one of the top rated articles!"
              />
            </Route>
            <Route exact path="/articles-list/articles/top5/top-contributor">
              <TopAuthorWithFetchHandler
                articles={top.topAuthor}
                message="Publish and be one of the top contributor"
              />
            </Route>
          </div>
          <Route>
            <NotFound />
          </Route>
        </Switch>
      </Router>
    </div>
  );
};

export default ArticleLists;
